/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
//import { useLocation } from "react-router";
//import { checkIsActive } from "../../../../_helpers";

export function AsideMenuList({ layoutProps }) {
  /* const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu && "menu-item-active"} menu-item-open `
      : "";
  }; */

  return <></>;
}
